import { createContext, useContext, useState } from "react";

const DrawerContext = createContext(null);

export function DrawerProvider({ children }) {
  const [openId, setOpenId] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const openLead = (id) => setOpenId(id);
  const close = () => setOpenId(null);
  const bump = () => setRefreshKey((k) => k + 1);
  return (
    <DrawerContext.Provider value={{ openId, openLead, close, bump, refreshKey }}>
      {children}
    </DrawerContext.Provider>
  );
}

export const useDrawer = () => useContext(DrawerContext);
